import actionTypes from "./actionTypes";
import store from "../../store";

export const setPathAnalyticsTab = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_PATH_ANALYTICS_TAB,
    payload: payload
  });
};

export const setSdwanSiteSummary = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_SDWAN_SITE_SUMMARY,
    payload: payload
  });
};

export const setSdwanSiteSummaryError = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_SDWAN_SITE_SUMMARY_ERROR,
    payload: payload
  });
};

export const setSdwanSiteSummaryLoader = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_SDWAN_SITE_SUMMARY_LOADER,
    payload: payload
  });
};

export const setTalosSites = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_TALOS_SITES,
    payload: payload
  });
};

export const setTalosError = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_TALOS_ERROR,
    payload: payload
  });
};

export const setTalosLoader = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_TALOS_LOADER,
    payload: payload
  });
};

export const setAnomalyRefresh = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_ANOMALY_REFRESH,
    payload: payload
  });
};

export const setSsoLogoutCookie = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_SSO_LOGOUT,
    payload: payload
  });
};

export const setSitesTableAvailability = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_SITES_TABLE_AVAILABILITY,
    payload: payload
  });
};

export const setOverviewSiteLoader = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_OVERVIEW_SITE_LOADER,
    payload: payload
  });
};

export const setOverviewDeviceLoader = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_OVERVIEW_DEVICE_LOADER,
    payload: payload
  });
};

export const setOverviewError = payload => ({
  type: actionTypes.SET_OVERVIEW_ERROR,
  payload: {
    errorObject: payload?.errorObject || {},
  }
});

export const setDeviceOverviewError = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_DEVICE_OVERVIEW_ERROR,
    payload: payload
  });
};

export const saveDeviceSiteData = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_DEVICE_SITE,
    payload: payload
  });
};

export const setOverlays = overlays => ({
  type: actionTypes.SET_OVERLAYS,
  payload: overlays
});

export const setSelectedOverlay = (overlayId, overlayName) => ({
  type: actionTypes.SET_SELECTED_OVERLAY,
  payload: {
    overlayId,
    overlayName
  }
});

export const setBreadCrumbs = breadCrumbsAry => ({
  type: actionTypes.SET_BREADCRUMBS,
  payload: breadCrumbsAry
});

export const setSites = sites => ({
  type: actionTypes.SET_SITES,
  payload: sites
});

export const setSelectedSite = site => ({
  type: actionTypes.SET_SELECTED_SITE,
  payload: site
});

export const setSelectedRemoteSite = remoteSite => ({
  type: actionTypes.SET_SELECTED_REMOTE_SITE,
  payload: remoteSite
});

export const setCtrlTimeFilter = (
  time_period,
  timePeriodSelected,
  time_frame
) => dispatch => {
  dispatch({
    type: actionTypes.SET_CTRL_TIME_FILTER,
    payload: {
      time_period,
      timePeriodSelected,
      time_frame
    }
  });
};

export const setCustomTime = time => ({
  type: actionTypes.SET_CUSTOM_TIME,
  payload: time
});

export const setSideBarTimeFilter = (
  time_period,
  timePeriodSelected
) => dispatch => {
  dispatch({
    type: actionTypes.SET_SIDE_BAR_TIME_FILTER,
    payload: {
      time_period,
      timePeriodSelected
    }
  });
};
export const setRefreshScreen = () => ({ type: actionTypes.SET_REFRESH });
export const setSideBarCustomTime = id => ({
  type: actionTypes.SET_SIDE_BAR_CUSTOM_TIME,
  payload: id
});

export const setAccounts = accounts => ({
  type: actionTypes.SET_ACCOUNTS,
  payload: accounts
});

export const setSelectedOverlayRoles = role => ({
  type: actionTypes.SET_SELECTED_OVERLAY_ROLES,
  payload: role
});

export const setAltoProps = altoProps => ({
  type: actionTypes.SET_ALTO_PROPS,
  payload: altoProps
});

export const setSupportRole = isSupportRole => ({
  type: actionTypes.SET_SUPPORT_ROLE,
  payload: isSupportRole
});

export const setCircuitsLoader = payload => ({
  type: actionTypes.setCircuitsLoader,
  payload
});

export const setCircuitsData = payload => ({
  type: actionTypes.setCircuitsData,
  payload
});

export const setAggregateAppData = aggregateApplications => {
  return {
    type: actionTypes.SET_APPLICATIONDATA_API_STATUS,
    payload: {
      data: aggregateApplications?.data,
      errorObject: aggregateApplications?.errorObject,
    }
  };
};

export const setAppFamilySLA = applications_sla => dispatch => {
  dispatch({
    type: actionTypes.SET_APP_FAMILY_SLA,
    payload: applications_sla
  });
};

export const setAppsWithFamilySLA = applications_sla => dispatch => {
  dispatch({
    type: actionTypes.SET_APP_DATA_WITH_FAMILY_SLA,
    payload: applications_sla
  });
};

export const setSelectedAppList = applications_sla => dispatch => {
  dispatch({
    type: actionTypes.SET_APP_DATA_SELECTED,
    payload: applications_sla
  });
};

export const setSelectedAppListLegend = applications_sla => dispatch => {
  dispatch({
    type: actionTypes.SET_APP_DATA_SELECTED_LEGEND,
    payload: applications_sla
  });
};

export const setPostLoginNotifications = payload => ({
  type: actionTypes.SET_POST_LOGIN_NOTIFICATIONS,
  payload
});

export const setMenuState = payload => ({
  type: actionTypes.SET_MENU_STATE,
  payload
});

export const setPrevSelectedAppList = applications_sla => dispatch => {
  dispatch({
    type: actionTypes.SET_PREV_APP_DATA_SELECTED,
    payload: applications_sla
  });
};

export const setSelectedAppListDefault = applications_sla => dispatch => {
  dispatch({
    type: actionTypes.SET_APP_DATA_SELECTED_DEFAULT,
    payload: applications_sla
  });
};

export const setTrendAnalysisFilter = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_TREND_ANALY_FILTER,
    payload: payload,
  });
};

export const setSidebarTableData = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_SIDEBAR_TABLE_DATA,
    payload: payload,
  });
};

export const setTimeframeFlowsWidget = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.TIMEFRAME_APP_FLOW,
    payload: payload,
  })
};

export const setPageToggle = selectedToggle => dispatch => {
  dispatch({
    type: actionTypes.SET_TOGGLE,
    payload: selectedToggle
  });
};


export const setNotificationInsightLoader = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_NOTIFICATION_INSIGHT_LOADER,
    payload: payload
  });
};

export const setNotificationInsight = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_NOTIFICATION_INSIGHT_DATA,
    payload: payload
  });
};

export const setNotificationInsightError = payload => dispatch => {
  dispatch({
    type: actionTypes.SET_NOTIFICATION_INSIGHT_ERROR,
    payload: payload
  });
};

export const setFeatures = payload => {
  store.dispatch({ type: actionTypes.features, payload: { ...payload } });
};

export const setAppFlowTableTime = (payload) => dispatch => {
  dispatch({
    type: actionTypes.SET_APP_FLOW_TABLE_TIME_TEXT,
    payload
  });
};

export const setAppFlowQuery = (payload) => dispatch => {
  dispatch({
    type: actionTypes.SET_APP_FLOW_QUERY,
    payload
  });
};

export const setOptimizationDonutChartData = (payload) => dispatch => {
  dispatch({
    type: actionTypes.SET_OPTIMIZATION_DONUT_CHART_DATA,
    payload
  });
};

export const setOptimizationDonutChartLoader = (payload) => dispatch => {
  dispatch({
    type: actionTypes.SET_OPTIMIZATION_DONUT_CHART_LOADER,
    payload
  });
};

export const setSelectedApplications = (selectionIds, data) => dispatch =>{
  const selectedApplications = data.filter(item => selectionIds.includes(item.id));
  dispatch({
    type: actionTypes.SET_SELECTED_APPLICATIONS,
    payload: selectedApplications
  });
};

export const setAppQoeTableLoader = (payload) => dispatch => {
  dispatch({
    type: actionTypes.SET_APP_QOE_TABLE_LOADER,
    payload
  });
};

export const setReportsDataCount = (payload) => dispatch => {
  dispatch({
    type: actionTypes.SET_REPORTS_DATA_COUNT,
    payload
  });
};
